import React from "react";

import { useDropzone } from "react-dropzone";
import { useNavigate } from 'react-router-dom';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import axios from "axios";
import CONFIG from '../../config';
import UploadIcon from '@mui/icons-material/Upload';


function WidgetDropZone({ type_dossier, document_name, user, setUser }) {
  const [loading, setLoading] = React.useState(0);
  const navigate = useNavigate();
  const onDrop = React.useCallback((acceptedFiles, fileRejections) => {
    fileRejections.forEach((file) => {
      file.errors.forEach((err) => {
        alert(err.code);
      });
    });

    let fd = new FormData();

    acceptedFiles.map((file) => {
      fd.append('file_list', file);
    });

    axios.post(CONFIG.API_URL + '/api/client_upload_file/' + user._id + '/' + type_dossier + '/' + document_name, fd, { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        setLoading((x) => x - acceptedFiles.length);
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;
        setLoading((x) => x - acceptedFiles.length);
        switch (response.status) {
          case 401:
            navigate('/connexion');
            break;

          default:
            break;
        }
      });
    setLoading((x) => x + acceptedFiles.length);
  }, [])

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone({ onDrop, accept: {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'application/pdf': ['.pdf'],
  } });

  return (
    <div {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      <div className={'grid grid-layout-12 justify-center text-center h-44 hover:bg-gray-100 ' + ((isDragActive) ? 'bg-gray-100' : 'bg-white') + ' border-2 border-dashed border-ame-orange cursor-pointer'}>
        <div className="grid-span-12 justify-center content-end grid">
          <UploadIcon sx={{ fontSize: 32, color: '#343A40' }} />
        </div>
        <div className="grid-span-12">
          <h4>Ajouter un fichier</h4>
          <span className="text-sm">(.png, .jpg, .jpeg, .pdf)</span>
          <br></br>
          <p class="text-xs">En cas de difficultés à déposer, utilisez un navigateur autre que Safari ou Internet Explorer.</p>
        </div>
        {loading !== 0 &&
          <>
            <div className="grid-span-12 flex items-center justify-center mb-1">
              <div className="flex pr-2">
                <AutorenewIcon className="animate-spin" sx={{ fontSize: 20, color: '#343A40' }} ></AutorenewIcon>
              </div>
              <div className="flex text-sm">
                Fichiers en cours d'envoi...
              </div>
            </div>
          </>
        }
      </div>
    </div>
  );
}

export default WidgetDropZone;